var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _g, _path4, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 120,
    viewBox: "0 0 193 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 24.375,
    width: 11.25,
    height: 71.25,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.625,
    y: 24.375,
    width: 11.25,
    height: 71.25,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 91.875,
    width: 22.5,
    height: 7.5,
    rx: 3.75,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 24.375,
    width: 11.25,
    height: 71.25,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 117.125,
    y: 24.375,
    width: 13.125,
    height: 71.25,
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.114 109.652L168.948 76.7881C169.934 73.1179 175.126 73.0748 176.174 76.728L185.597 109.591C186.284 111.988 184.485 114.375 181.992 114.375H163.735C161.268 114.375 159.473 112.034 160.114 109.652Z",
    stroke: "black",
    strokeWidth: 3.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1950_63294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 74,
    width: 27,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.114 109.652L168.948 76.7881C169.934 73.1179 175.126 73.0748 176.174 76.728L185.597 109.591C186.284 111.988 184.485 114.375 181.992 114.375H163.735C161.268 114.375 159.473 112.034 160.114 109.652Z",
    fill: "#212A35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.114 109.652L168.948 76.7881C169.934 73.1179 175.126 73.0748 176.174 76.728L185.597 109.591C186.284 111.988 184.485 114.375 181.992 114.375H163.735C161.268 114.375 159.473 112.034 160.114 109.652Z",
    stroke: "#212A35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1950_63294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.875 80.625H182.75V86.25H165.875V80.625Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25 91.875H185.563V97.5H160.25V91.875Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.438 103.125H188.375V108.75H157.438V103.125Z",
    fill: "#FFC700"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.114 109.652L168.948 76.7881C169.934 73.1179 175.126 73.0748 176.174 76.728L185.597 109.591C186.284 111.988 184.485 114.375 181.992 114.375H163.735C161.268 114.375 159.473 112.034 160.114 109.652Z",
    stroke: "black",
    strokeWidth: 3.75
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 110.625,
    width: 32.8125,
    height: 7.5,
    rx: 3.75,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 113.375,
    y: 91.875,
    width: 22.5,
    height: 7.5,
    rx: 3.75,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 1.875,
    width: 37.5,
    height: 22.5,
    rx: 3.75,
    fill: "#212A35",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 1.875,
    width: 142.5,
    height: 22.5,
    rx: 5.625,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 39.375,
    width: 37.5,
    height: 22.5,
    rx: 3.75,
    fill: "#212A35",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 39.375,
    width: 142.5,
    height: 22.5,
    rx: 5.625,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 3.75H49.625L30.875 22.5H15.875L34.625 3.75Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.625 3.75H79.625L60.875 22.5H45.875L64.625 3.75Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.625 3.75H109.625L90.875 22.5H75.875L94.625 3.75Z",
    fill: "#FFC700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.625 3.75H139.625L120.875 22.5H105.875L124.625 3.75Z",
    fill: "#FFC700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 41.25H49.625L30.875 60H15.875L34.625 41.25Z",
    fill: "#FFC700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.625 41.25H79.625L60.875 60H45.875L64.625 41.25Z",
    fill: "#FFC700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.625 41.25H109.625L90.875 60H75.875L94.625 41.25Z",
    fill: "#FFC700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.625 41.25H139.625L120.875 60H105.875L124.625 41.25Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadBlock);
export default __webpack_public_path__ + "static/media/roadBlock.d9edc153a0f364f179636313c98a1912.svg";
export { ForwardRef as ReactComponent };